import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
    { id: "home", label: "Home", testId: "nav-item-home" },
    { id: "what-we-do", label: "What We Do", testId: "nav-item-what-we-do" },
    { id: "why-a-website", label: "Why A Website", testId: "nav-item-why-a-website" },
    { id: "contact", label: "Contact", testId: "nav-item-contact" },
];

export const Navbar = ({ onNavigate }) => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (id) => {
        setOpen(false);
        onNavigate(`#${id}`);
    };

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,box-shadow] duration-300 border-b ${
                scrolled || open
                    ? "bg-white/85 backdrop-blur-md border-zinc-200"
                    : "bg-transparent border-transparent"
            }`}
        >
            <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                <button
                    data-testid="nav-logo-link"
                    onClick={() => go("home")}
                    className="focus:outline-none"
                    aria-label="Emira Digital — home"
                >
                    <Logo inverted={!scrolled && !open} />
                </button>

                <div className="hidden md:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={l.testId}
                            onClick={() => go(l.id)}
                            className={`text-sm font-medium transition-colors duration-200 hover:text-blue-600 ${
                                scrolled ? "text-zinc-700" : "text-zinc-300"
                            }`}
                        >
                            {l.label}
                        </button>
                    ))}
                </div>

                <button
                    data-testid="nav-mobile-menu-button"
                    className={`md:hidden p-2 ${scrolled || open ? "text-zinc-900" : "text-zinc-100"}`}
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </nav>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="md:hidden bg-white border-t border-zinc-200 px-4 py-4 flex flex-col gap-1"
                >
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`${l.testId}-mobile`}
                            onClick={() => go(l.id)}
                            className="text-left text-base font-medium text-zinc-800 py-2.5 px-2 rounded-md hover:bg-zinc-100 transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                </div>
            )}
        </header>
    );
};
